<template>
  <el-dialog class="add-price" title="创建实际价格" width="580px" :visible.sync="dialogFormVisible">

    <el-form :model="formData" :rules="rules" ref="ruleForm">

      <el-form-item label="省份" prop="sfenid" :label-width="formLabelWidth">
        <el-select v-model="formData.sfenid" placeholder="请选择省份" style="width: 100%;">
          <el-option v-for="item in provinceList" :key="item.sfid" :label="item.sfen" :value="item.sfid"
            style="width:100%">
          </el-option>
        </el-select>
      </el-form-item>

      <el-row type="flex" :gutter="8">
        <el-col :span="14">
          <el-form-item label="回收类型" prop="spid" :label-width="formLabelWidth">
            <el-select v-model="formData.spid" @change="() => { formData.xlid = ''; formData.xhid = ''; getSpXiaolei() }"
              placeholder="请选择回收类型" style="width: 100%;">
              <el-option v-for="item in dlList" :key="item.spid" :label="item.spmc" :value="item.spid"
                style="width:100%"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="xlid">
            <el-select v-model="formData.xlid" :disabled="!formData.spid"
              @change="() => { formData.xhid = ''; getSpModel() }" placeholder="请选择回收类型" style="width: 100%;">
              <el-option v-for="item in xlList" :key="item.xlid" :label="item.xlmc" :value="item.xlid" style="width:100%">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item v-if="modelList.length !== 0" label="规格" prop="xhid" :label-width="formLabelWidth">
        <el-select v-model="formData.xhid" :disabled="!formData.xlid" placeholder="请选择规格" style="width: 100%;">
          <el-option v-for="item in modelList" :key="item.xhid" :label="item.xhmc" :value="item.xhid" style="width:100%">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="isNeedRelativeEnum" label="品牌" prop="brand" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.brand">
          <el-radio v-for="item in brandList" :label="item.key" :key="item.key">{{ item.value }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isNeedRelativeEnum" label="是否含管" prop="pipe" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.pipe">
          <el-radio v-for="item in pipeList" :label="item.key" :key="item.key">{{ item.value }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isNeedRelativeEnum" label="单双片" prop="pane" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.pane">
          <el-radio v-for="item in paneList" :label="item.key" :key="item.key">{{ item.value }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isNeedRelativeEnum" label="年限" prop="age" :label-width="formLabelWidth">
        <el-select v-model="formData.age" placeholder="请选择年限" style="width: 100%;">
          <el-option v-for="item in yearList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="回收价格" prop="price" :label-width="formLabelWidth">
        <el-input-number v-model="formData.price" auto-complete="off" style="width: 100%;" :min="0"
          label="回收价格"></el-input-number>
      </el-form-item>

      <el-form-item v-if="isNeedRelativeEnum" label="单位" prop="unit" :label-width="formLabelWidth">
        <el-select v-model="formData.unit" placeholder="请选择单位" style="width: 100%;">
          <el-option v-for="item in unitList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelSubmit">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitForm">确 定</el-button>
    </div>

  </el-dialog>
</template>
<script>
export default {
  props: {
    provinceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    dlList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      /**
       * pageType 页面类型 add edit
       * editId 编辑id
       * dialogFormVisible 弹框状态
       * formData 表单数据
       * provinceList 省市列表
       * dlList 回收大类
       * xlList 回收小类
       * modelList 回收规格
       * // 下方所说列表只针对空调 spid = 101
       * brandList 品牌列表
       * pipeList 是否含管列表
       * paneList 单双片列表
       * yearList 年限列表
       * unitList 单位列表
       * tempSaveDataObj 枚举获取过数据所保存的数据
       */
      pageType: 'add',
      editId: '',
      dialogFormVisible: false,
      formData: {
        sfenid: '',
        spid: '',
        xlid: '',
        xhid: '',
        brand: undefined,
        pipe: undefined,
        pane: undefined,
        age: undefined,
        price: 0,
        unit: undefined
      },
      // provinceList: [],
      // dlList: [],
      xlList: [],
      modelList: [],
      brandList: [],
      pipeList: [],
      paneList: [],
      yearList: [],
      unitList: [],
      formLabelWidth: '120px',
      rules: {
        sfenid: [
          { required: true, message: '请选择省份', trigger: 'change' }
        ],
        spid: [
          { required: true, message: '请选择回收类型', trigger: 'change' }
        ],
        xlid: [
          { required: true, message: '请选择回收小类', trigger: 'change' }
        ],
        xhid: [
          { required: true, message: '请选择回收规格', trigger: 'change' }
        ],
        brand: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        pipe: [
          { required: true, message: '请选择是否含管', trigger: 'change' }
        ],
        pane: [
          { required: true, message: '请选择单双片', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请选择年限', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入回收价格', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请选择单位', trigger: 'change' }
        ]
      },
      tempSaveDataObj: {
        brandList: [],
        pipeList: [],
        paneList: [],
        yearList: [],
        unitList: [],
      },
      btnLoading: false
    }
  },
  watch: {
    'formData.spid': function (val, oldVal) {
      // console.log('===val===', val)
      if (val == 101) {
        this.initGetData()
      } else {
        this.clearRelativeListData()
      }
    },
    dialogFormVisible: function (val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields()
      }
    }
  },
  computed: {
    // 空调才需要相关枚举
    isNeedRelativeEnum: function () {
      return this.formData.spid == 101
    }
  },
  methods: {
    openDialog (pageType = 'add', editData = {}) {
      this.pageType = pageType
      this.formData = {
        sfenid: '',
        spid: '',
        xlid: '',
        xhid: '',
        brand: undefined,
        pipe: undefined,
        pane: undefined,
        age: undefined,
        price: 0,
        unit: undefined
      }
      if (pageType === 'add') {
        this.dialogFormVisible = true
        return
      }
      if (pageType === 'edit') {
        this.editId = editData.id
        for (let item in this.formData) {
          this.formData[item] = editData[item]
        }
        if (editData.spid == 101) {
          this.initGetData()
        }
        if (this.formData.spid) {
          this.getSpXiaolei()
        }
        if (this.formData.xlid) {
          this.getSpModel()
        }
        this.dialogFormVisible = true
        return
      }
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('==== submit ====', this.formData)
          this.btnLoading = true
          let sfObj = this.provinceList.find((item) => item.sfid == this.formData.sfenid) || ''
          let sfen = sfObj ? sfObj.sfen : ''

          let spmcObj = this.dlList.find((item) => item.spid == this.formData.spid) || ''
          let spmc = spmcObj ? spmcObj.spmc : ''

          let xlmcObj = this.xlList.find((item) => item.xlid == this.formData.xlid) || ''
          let xlmc = xlmcObj ? xlmcObj.xlmc : ''

          let xhmcObj = this.modelList.find((item) => item.xhid == this.formData.xhid) || ''
          let xhmc = xhmcObj ? xhmcObj.xhmc : ''

          let status = 1
          const otherParams = {
            id: this.pageType === 'edit' ? this.editId : undefined,
            sfen,
            spmc,
            xlmc,
            xhmc,
            status
          }
          const params = Object.assign({}, this.formData, otherParams)
          // 判断是否是空调，把多余参数去除，避免选择空调和对应枚举值再切换残留枚举值提交
          if (!this.isNeedRelativeEnum) {
            delete params.brand
            delete params.pipe
            delete params.pane
            delete params.age
            delete params.unit
          }
          this.saveFormDataReq(params)
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 保存和编辑数据接口
    saveFormDataReq (params) {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/save'
      this.HttpService.post(url, params).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          const tipMsg = this.pageType === 'add' ? '新增成功' : '修改成功'
          this.$message.success(tipMsg)
          this.dialogFormVisible = false
          this.$emit('opera-success')
        } else {
          const tipMsg = res.message || '操作失败'
          this.$message.error(tipMsg)
        }
      })
    },
    // 取消提交
    cancelSubmit () {
      this.dialogFormVisible = false
    },
    // 获取基本枚举数据
    initGetData () {
      this.yearList = this.tempSaveDataObj.yearList || []
      if (this.yearList.length === 0) {
        this.getYearList()
      }

      this.brandList = this.tempSaveDataObj.brandList || []
      if (this.brandList.length === 0) {
        this.getBrandList()
      }

      this.pipeList = this.tempSaveDataObj.pipeList || []
      if (this.pipeList.length === 0) {
        this.getPaneList()
      }

      this.paneList = this.tempSaveDataObj.paneList || []
      if (this.paneList.length === 0) {
        this.getPipeList()
      }

      this.unitList = this.tempSaveDataObj.unitList
      if (this.unitList.length === 0) {
        this.getUnitList()
      }
    },
    // 获取小类
    getSpXiaolei () {
      this.xlList = []
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tblSplbYxypSubcategory/getBatchSubCategoryBySpid?isValid=1&spid=${this.formData.spid}`).then(res => {
        if (res.statusCode === 200) {
          this.xlList = res.data
        }
      })
    },
    // 获取机型
    getSpModel () {
      this.modelList = []
      let params = {
        flag: 1,
        spid: this.formData.spid,
        xlid: this.formData.xlid
      }
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tblSplbYxypSubcategory/getBatchSpecificationByXlid?isValid=1&xlid=${this.formData.xlid}`, params).then(res => {
        if (res.statusCode === 200) {
          this.modelList = res.data
        }
      })
    },
    // 获取年限枚举
    getYearList () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/getAgeEnum'
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.yearList = res.data || []
          this.tempSaveDataObj['yearList'] = res.data || []
        }
      })
    },
    // 获取品牌枚举
    getBrandList () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/getBrandEnum'
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.brandList = res.data || []
          this.tempSaveDataObj['brandList'] = res.data || []
        }
      })
    },
    // 获取单双片枚举
    getPaneList () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/getPaneEnum'
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.paneList = res.data || []
          this.tempSaveDataObj['paneList'] = res.data || []
        }
      })
    },
    // 获取含管枚举
    getPipeList () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/getPipeEnum'
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.pipeList = res.data || []
          this.tempSaveDataObj['pipeList'] = res.data || []
        }
      })
    },
    // 获取单位枚举
    getUnitList () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/getUnitEnum'
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.unitList = res.data || []
          this.tempSaveDataObj['unitList'] = res.data || []
        }
      })
    },
    // 清空只有空调的才有的枚举
    clearRelativeListData () {
      this.modelList = []
      this.brandList = []
      this.pipeList = []
      this.paneList = []
      this.yearList = []
      this.unitList = []
    }
  }
}
</script>
<style lang='scss'>
.add-price {
  .dialog-footer {
    padding: 20px 60px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/component/AddActualPriceDialog.vue